import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mwMinutesToTimeDuration',
})
export class MwMinutesToTimeDurationPipe implements PipeTransform {
  transform(minutes: number, useDecimalFormat: boolean = false): string {
    if (useDecimalFormat) {
      return minutes.toFixed(2).toString();
    }

    const isNegative = minutes < 0;
    minutes = Math.abs(minutes);

    const hoursPart = Math.floor(minutes / 60);
    const minutesPart = Math.round(minutes % 60);

    const hoursPartString =
      hoursPart < 10 ? `0${hoursPart}` : hoursPart.toString();
    const minutesPartString =
      minutesPart < 10 ? `0${minutesPart}` : minutesPart.toString();

    return `${isNegative ? '-' : ''}${hoursPartString}:${minutesPartString}`;
  }
}
